import React from "react";
import styles from './LogReportCard.module.scss';
import { getDayFromDate, getMonthYearFromDate } from "../../utils/timeUtils";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {ReactComponent as ChevronRightIcon} from './ChevronRight.svg';
import {ReactComponent as XIcon} from './X.svg';
import { toCamelCase } from "../../utils/stringUtils";

const LogReportCard = ({
  date,
  data,
  cta,
  status,
  onDelete,
  type
}) => {
  return (
    <div className={`${type === 'Clinical' ? styles.border : styles.noBorder} ${styles[toCamelCase(status)] ?? ''}`}>
      <div className={`${type === 'Clinical' ? styles.border : styles.noBorder} ${styles[toCamelCase(status)] ?? ''}`}>
        <div className={`${styles.card} ${styles[toCamelCase(status)] ?? ''}`}>
          {onDelete && ['Incomplete', 'Past Due'].includes(status) && <div className={styles.close}>
            <XIcon onClick={() => onDelete()}/>
          </div>}
          <div className={styles.content}>
            <div className={styles.date}>
              <div className={`${styles.day} ${styles[toCamelCase(status)] ?? ''}`}>{getDayFromDate(date)}</div>
              <div className={styles.month}>{getMonthYearFromDate(date)}</div>
            </div>
            <table className={styles.dataTable}>
              <tbody>
                {data.map((item) => (
                  <tr key={item.label}>
                    <th>{item.label}</th>
                    <td>{item.text}</td>
                  </tr>
                ))}
                <tr>
                  <th>Status</th>
                  <td className={styles[toCamelCase(status)] ?? ''}>{status}</td>
                </tr>
              </tbody>
            </table>
          </div>
          {cta && <div className={styles.cta}>
            <Link to={cta.link}>{cta.label}<ChevronRightIcon /></Link>
          </div>}
        </div>
      </div>
    </div>
  );
};

LogReportCard.propTypes = {
  date: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      text: PropTypes.any.isRequired,
    })
  ).isRequired,
  cta: PropTypes.shape({
    label: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired
  }),
  status: PropTypes.oneOf(['Incomplete', 'Submitted', 'Past Due', 'Deleted']).isRequired,
  onDelete: PropTypes.func,
  type: PropTypes.oneOf(['Clinical', 'Reading Day']).isRequired,
}

export default LogReportCard;